import React, {PureComponent} from "react"
import {Col, Row} from "react-bootstrap"
import {FormattedMessage} from "@irati/utils/lang"
import {Hr} from "@irati/ui/src/Layout"
import Markdown from "@irati/ui/src/Markdown"
import {Reward} from "@irati/types"
import SectionTitle from "./styled/SectionTitle"

interface Props {
  reward: Reward
}

export default class RewardDeliveryInfo extends PureComponent<Props> {
  render() {
    const {reward} = this.props

    return (
      <section>
        <Hr large />
        <SectionTitle>
          <FormattedMessage id="reward.detail.deliveryInfo.title" />
        </SectionTitle>
        <Row>
          <Col xs={12}>
            <Markdown source={reward.deliveryInfo} />
          </Col>
        </Row>
      </section>
    )
  }
}
